import React from 'react';
import { Robot, Spinner, Lightning } from '@phosphor-icons/react';

export const ConcernHeader = ({ userConcern, running, run, analysis, confColor }) => (
  <>
    <div className="flex items-start justify-between mb-3 flex-wrap gap-2">
      <div>
        <h3 className="font-outfit text-lg font-semibold text-[#09090B] flex items-center gap-2">
          <Robot size={20} className="text-[#002FA7]" /> Concern-Focused Analysis
        </h3>
        <p className="text-xs text-[#6B7280] font-ibm mt-1">AI reviews your stated concern against the uploaded documents and the applicable laws panel. Strict facts only — no guesses, no hallucinations.</p>
      </div>
    </div>

    <div className="p-3 bg-[#F9FAFB] border border-[#E5E7EB] rounded-md mb-3">
      <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm mb-1">Your stated concern</p>
      {userConcern ? (
        <p className="text-sm font-ibm text-[#09090B] whitespace-pre-wrap">{userConcern}</p>
      ) : (
        <p className="text-sm font-ibm italic text-[#6B7280]">No concern description on file. Edit this case and add a description of what you're investigating, then re-run.</p>
      )}
    </div>

    <div className="flex items-center gap-2 mb-3 flex-wrap">
      <button onClick={run} disabled={running || !userConcern} data-testid="concern-analyze-button"
        className="flex items-center gap-1.5 px-3 py-2 text-sm bg-[#002FA7] text-white font-ibm font-semibold rounded-md hover:bg-[#00237D] transition-all disabled:opacity-50">
        {running ? <><Spinner size={14} className="animate-spin" /> Analyzing...</> : <><Lightning size={14} /> {analysis ? 'Re-run Deep Analysis' : 'Run Deep Analysis'}</>}
      </button>
      {analysis?.confidence && (
        <span className={`text-xs font-ibm px-2 py-1 rounded border ${confColor(analysis.confidence)}`}>
          Confidence: {analysis.confidence}
        </span>
      )}
      {analysis?.generated_at && (
        <span className="text-[11px] text-[#9CA3AF] font-ibm">Last run: {new Date(analysis.generated_at).toLocaleString()}</span>
      )}
    </div>

    {running && (
      <div className="mt-3 p-4 border border-dashed border-[#E5E7EB] rounded-md text-center">
        <Spinner size={20} className="animate-spin inline text-[#002FA7]" />
        <p className="text-sm text-[#6B7280] font-ibm mt-2">Cross-referencing documents, timeline, contradictions and the Laws panel. This may take 30–60 seconds…</p>
      </div>
    )}
  </>
);
